/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type PhoneTypeEnum = (typeof PhoneTypeEnum)[keyof typeof PhoneTypeEnum];

export const PhoneTypeEnum = {
  cell: 'cell',
  home: 'home',
  work: 'work',
} as const;
